export default class CountdownResponse {
    constructor(
        public minutes: number,
        public errorMessages: string[],
    ) { }
}